<template>
  <v-container>
    <div class="headline-container">
      <v-row justify="space-between" align="center">
        <v-col cols="12" md="6">
          <span class="headline">Statistik Surat</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="4" v-if="hasPrivateAccess">
          <v-autocomplete
            prepend-icon="mdi-account"
            label="Pengolah Surat"
            v-model="id_pengolah"
            item-value="id"
            item-text="name"
            :items="$store.state.pejabats"
            clearable
            :menu-props="{ closeOnContentClick: true }"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col cols="12" md="9">
        <Summary :id_pengolah="id_pengolah" />
        <div class="divider" />
        <Chart :id_pengolah="id_pengolah" />
      </v-col>
      <v-col cols="12" md="3">
        <DailyInboxSummary v-if="hasPrivateAccess" />
        <div class="divider" v-if="hasPrivateAccess" />
        <DailyOutboxSummary v-if="hasPrivateAccess" />
        <div class="divider" v-if="hasPrivateAccess" />
        <ChartJenisSurat :id_pengolah="id_pengolah" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Summary from './Summary'
import Chart from './Chart'
import DailyInboxSummary from './DailySummary/Inbox'
import DailyOutboxSummary from './DailySummary/Outbox'
import ChartJenisSurat from './Chart/JenisSurat'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    Summary,
    Chart,
    ChartJenisSurat,
    DailyInboxSummary,
    DailyOutboxSummary
  },
  computed: {
    ...mapGetters(['hasPrivateAccess'])
  },
  data() {
    return {
      year: moment().format('YYYY'),
      id_pengolah: null
    }
  },
  mounted() {
    if (this.hasPrivateAccess) {
      this.$store.dispatch('loadJabatan')
    }
  }
}
</script>

<style scoped>
.divider {
  height: 30px;
}
.headline-container {
  margin: 0 !important;
}
</style>
